import RegistrationDocumentsTabList from ".";
import { RegistrationDocumentsFinepProvider } from "../../../Contexts/RegistrationDocumentsFinepContext";

const TabRegistrationDocumentsFinepContextChildren = () => {
    return (
        <RegistrationDocumentsFinepProvider>
            <RegistrationDocumentsTabList />
        </RegistrationDocumentsFinepProvider>
    );
}

export default TabRegistrationDocumentsFinepContextChildren;